import { __assign, __rest } from "tslib";
import React, { memo, useContext } from 'react';
import { Field } from 'react-final-form';
import stringify from 'fast-safe-stringify';
import { FormContext } from '../utils/FormContext';
import { resolveUseSamePath } from '../utils/resolveUseSamePath';
import { nestedResolveUseSamePath } from '../utils/nestedResolveUseSamePath';
export var CustomField = memo(function (_a) {
    var _b, _c, _d;
    var field = _a.field, name = _a.name, rest = __rest(_a, ["field", "name"]);
    var validations = field.validations, associatedValidationBasedOnOtherFieldValues = field.associatedValidationBasedOnOtherFieldValues, arrayOfFieldsToRevalidateOnChange = field.arrayOfFieldsToRevalidateOnChange, _e = field.partialFieldProps, partialFieldProps = _e === void 0 ? {} : _e;
    var _f = useContext(FormContext), validationCallback = _f.validationCallback, showErrorsOnInitialRender = _f.showErrorsOnInitialRender;
    var updatedConditions = nestedResolveUseSamePath((_c = (_b = associatedValidationBasedOnOtherFieldValues === null || associatedValidationBasedOnOtherFieldValues === void 0 ? void 0 : associatedValidationBasedOnOtherFieldValues.conditionalFields) === null || _b === void 0 ? void 0 : _b.conditions) !== null && _c !== void 0 ? _c : [], name);
    var updatedAssociatedValidationBasedOnOtherFieldValues = {
        logicalOperator: (_d = associatedValidationBasedOnOtherFieldValues === null || associatedValidationBasedOnOtherFieldValues === void 0 ? void 0 : associatedValidationBasedOnOtherFieldValues.conditionalFields) === null || _d === void 0 ? void 0 : _d.logicalOperator,
        conditions: updatedConditions,
    };
    var validateMethod = function () { return null; };
    if ((validations || associatedValidationBasedOnOtherFieldValues) &&
        validationCallback) {
        validateMethod = function (fieldValue, allValues) {
            return validationCallback(fieldValue, validations, allValues, {
                conditionalFields: updatedAssociatedValidationBasedOnOtherFieldValues,
                rules: associatedValidationBasedOnOtherFieldValues === null || associatedValidationBasedOnOtherFieldValues === void 0 ? void 0 : associatedValidationBasedOnOtherFieldValues.rules,
                message: associatedValidationBasedOnOtherFieldValues === null || associatedValidationBasedOnOtherFieldValues === void 0 ? void 0 : associatedValidationBasedOnOtherFieldValues.message,
            });
        };
    }
    var validateFields = arrayOfFieldsToRevalidateOnChange === null || arrayOfFieldsToRevalidateOnChange === void 0 ? void 0 : arrayOfFieldsToRevalidateOnChange.map(function (fieldToRevalidate) {
        if (fieldToRevalidate.useSamePath) {
            return resolveUseSamePath(name, fieldToRevalidate.fieldName);
        }
        return fieldToRevalidate.fieldName;
    });
    var _g = partialFieldProps.parse, parse = _g === void 0 ? function (val) { return val; } : _g;
    return (React.createElement(Field, __assign({}, partialFieldProps, field, rest, { parse: parse, name: name, render: field.render, showErrorsOnInitialRender: showErrorsOnInitialRender, validate: validateMethod, validateFields: validateFields })));
}, function (prevProps, nextProps) {
    try {
        return stringify(prevProps) === stringify(nextProps);
    }
    catch (e) {
        console.warn("CustomField: ".concat(e));
        return false;
    }
});
CustomField.displayName = 'CustomField';
